import { Note, NoteTypes } from '../../models/domain/note';
import { NoteManager } from '../../managers/note.manager';

import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Title } from '@angular/platform-browser';
import { AfterViewInit, Component, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { NoteDetailsFullComponent } from './components/note.details.full/note.details.full.component';
import { ManagerModeTypes } from '../../managers/manager.base';
import { Member } from '../../models/domain/member';
import { License } from '../../models/domain/license';
import { CreditCard } from '../../models/domain/credit.card';
import { GISBundleLogItem } from '../../models/domain/gis.bundle.log.item';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../../app/services/ss-api.service';
import { Router } from '@angular/router';


export interface INoteDetailsDialogModel {
  noteManager: NoteManager;
}

@Component({
  selector: 'note-details-dialog',
  styleUrls: ['./note.details.dialog.css'],
  templateUrl: './note.details.dialog.html'
})
export class NoteDetailsDialog extends DialogComponent<INoteDetailsDialogModel, boolean> implements INoteDetailsDialogModel, AfterViewInit, OnDestroy {

  // managers
  noteManager: NoteManager;

  // browser Title
  private originalTitle: string;

  // titles
  dialogTitle: string;
  dialogSubTitle: string;

  member: Member;

    //Hotkey
    @HostListener('window:keydown.alt.v', ['$event'])
    saveNoteHotkey(event: KeyboardEvent) {
        event.preventDefault();
        this.confirm();
    }  

  // viewchield
  @ViewChild(NoteDetailsFullComponent) noteDetailsFull: NoteDetailsFullComponent;

  constructor(dialogService: DialogService, private titleService: Title, private sweetAlertService: SweetAlertService, private api: ssApiService, public gb: GlobalService, public router: Router) {
    super(dialogService, router);
  }


  ngAfterViewInit() {
    // this.SetBrowserTitle();
    this.GenerateDialogTitles();

    /*let disposable = this.api.MemberFull(this.noteManager.Note().MemberID).subscribe( response => {
      disposable.unsubscribe();
      console.log("MemberFull Response", response);
      this.member = response.Data;

    }, error => {
      disposable.unsubscribe();
      console.log("MemberFull call ERROR", error);
    });
    */
  }


  SetBrowserTitle() {
    this.originalTitle = this.titleService.getTitle();

    // generate a title
    let appendValue = (this.noteManager.ModeType() == ManagerModeTypes.Edit) ? ' (EN)' : ' (CN)' // EN = edit note, CN = create note
    let title = this.noteManager.Note().RelationInfo + appendValue;

    // check relation object
    let noteRelationObject = this.noteManager.Note().RelationObject

    if (noteRelationObject === undefined || noteRelationObject == null) {
      // we don't have a relationobject
      this.titleService.setTitle(title);
      return;
    }

    // we do have a relationobject
    switch (Note.GetNoteType(this.noteManager.Note())) {

      case NoteTypes.Member:
        let member = (<Member>noteRelationObject)
        title = member.FirstName + ' ' + member.LastName + appendValue;
        break;

      case NoteTypes.LicenseKey:
        let license = (<License>noteRelationObject);
        title = license.Key + appendValue;
        break;

      case NoteTypes.CreditCard:
        let CreditCard = (<CreditCard>noteRelationObject);
        title = 'CreditCard: ' + CreditCard.LastFour + appendValue;
        break;

      case NoteTypes.GISCredit:
        let GIS = (<GISBundleLogItem>noteRelationObject);
        title = 'GIS: ' + GIS.ID + appendValue;
        break;
    }

    // set title
    this.titleService.setTitle(title);

  }


  GenerateDialogTitles() {
    this.GenerateDialogTitle();
    this.GenerateDialogSubTitles();
  }


  GenerateDialogTitle() {

    if (this.noteManager.ModeType() == ManagerModeTypes.Add) {
      this.dialogTitle = 'Create New Note';
    } else if (this.noteManager.ModeType() == ManagerModeTypes.Edit) {
      this.dialogTitle = 'Edit Note';
    }

  }


  GenerateDialogSubTitles() {

    let allTypes = this.noteManager.Note().NoteTypeList;

    let memberName: string = '';

    if (this.member)
      memberName = this.member.FirstName + ' ' + this.member.LastName;

    // this.dialogSubTitle = "Member: " + memberName;

    if (this.noteManager.Note().MemberFullName) {
      this.dialogSubTitle = 'Member: ' + this.noteManager.Note().MemberFullName;
    } else {
      this.dialogSubTitle = 'Member: ' + this.noteManager.Note().RelationObject.FirstName + ' ' + this.noteManager.Note().RelationObject.LastName;
    }

    if ( this.noteManager.Note().DesignerFullName != null ) {
      this.dialogSubTitle += ' | Designer: ' + this.noteManager.Note().DesignerFullName;
    }

    allTypes.forEach((type) => {
      switch (type.Key) {

        case NoteTypes.Member:
          // this.dialogSubTitle += " | Member ID: " + type.Value;
          break;

        case NoteTypes.LicenseKey:
          // this.dialogSubTitle += " | License Key ID: " + type.Value;
          break;

        case NoteTypes.GISCredit:
          this.dialogSubTitle += ' | GIS Credit ID: ' + type.Value;
          break;

        case NoteTypes.CreditCard:
          this.dialogSubTitle += ' | CreditCard ID: ' + type.Value;
          break;
      }
    });

  }



  ngOnDestroy() {
    this.titleService.setTitle(this.originalTitle);
  }


  confirm() {

    let saved = this.noteManager.OnChangesSaveResponse.subscribe(response => {
      saved.unsubscribe();

      if (response.Result)
        this.result = true;
        this.close();
    })

    this.noteManager.SaveChanges(false, true);
  }


  Close() {

    if (this.noteManager.Edited()) {
      // the note was edited

      // dialog
      this.noteDetailsFull.SaveConfirm(
        this.noteDetailsFull.NoteManager.Note(),

        // on save
        () => {
          let saved = this.noteManager.OnChangesSaveResponse.subscribe(response => {
            saved.unsubscribe();
            super.close();
          })

          this.noteManager.SaveChanges(false, true);
        },

        // on calcel
        () => {
          super.close();
        }
      );

      return;
    };

    // not edited
    super.close();
  }

}
